import * as React from "react";

export const ExcelIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 10 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1.6C0 0.7175 0.7175 0 1.6 0H5.3375C5.7625 0 6.17 0.1675 6.47 0.4675L9.1325 3.1325C9.4325 3.4325 9.6 3.84 9.6 4.265V11.2C9.6 12.0825 8.8825 12.8 8 12.8H1.6C0.7175 12.8 0 12.0825 0 11.2V1.6ZM5.2 1.4625V3.8C5.2 4.1325 5.4675 4.4 5.8 4.4H8.1375L5.2 1.4625ZM4.1 6.6675C3.915 6.3925 3.5425 6.3175 3.2675 6.5C2.9925 6.6825 2.9175 7.0575 3.1 7.3325L4.08 8.8L3.1 10.2675C2.915 10.5425 2.99 10.915 3.2675 11.1C3.545 11.285 3.915 11.21 4.1 10.9325L4.8 9.8825L5.5 10.9325C5.685 11.2075 6.0575 11.2825 6.3325 11.1C6.6075 10.9175 6.6825 10.5425 6.5 10.2675L5.52 8.8L6.5 7.3325C6.685 7.0575 6.61 6.685 6.3325 6.5C6.055 6.315 5.685 6.39 5.5 6.6675L4.8 7.7175L4.1 6.6675Z"
      fill="#99A0A7"
    />
  </svg>
);
